const listeners = new Set();

let cache = { id: null, role: null };
let inflight = null;

const emit = (payload) => {
  listeners.forEach((listener) => listener(payload));
};

export const getCachedUserRoleAccess = (roleId) => {
  if (!roleId || cache.id !== String(roleId)) return null;
  return cache.role;
};

export const subscribeUserRoleAccess = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const invalidateUserRoleAccess = () => {
  cache = { id: null, role: null };
  inflight = null;
  emit({ invalidated: true });
};

export const resetUserRoleAccessCache = () => {
  cache = { id: null, role: null };
  inflight = null;
};

export const loadUserRoleAccess = async (
  roleId,
  fetcher,
  { force = false } = {}
) => {
  if (!roleId || typeof fetcher !== "function") return null;
  const id = String(roleId);
  if (!force && cache.id === id && cache.role) return cache.role;
  if (inflight) return inflight;

  inflight = Promise.resolve()
    .then(() => fetcher(id))
    .then((role) => {
      if (role) {
        cache = { id, role };
        emit({ role });
      }
      return role ?? null;
    })
    .finally(() => {
      inflight = null;
    });

  return inflight;
};
